import { FuseNavItemType } from '@fuse/core/FuseNavigation/types/FuseNavItemType';

const navigationConfig: FuseNavItemType[] = [
	{
		id: 'dashboard',
		title: 'Dashboard',
		type: 'item',
		icon: 'lucide:layout-dashboard',
		url: 'dashboard'
	},
	{
		id: 'group-manage',
		title: 'Manage',
		type: 'group',
		children: [
			{
				id: 'settings',
				title: 'Settings',
				type: 'item',
				icon: 'lucide:sliders-horizontal',
				url: 'settings'
			}
		]
	},
	{
		id: 'group-inbox',
		title: 'Inbox',
		type: 'group',
		children: [
			{
				id: 'inbox.contact',
				title: 'Contact',
				type: 'item',
				icon: 'lucide:mail',
				url: 'contact'
			}
		]
	},
	{
		id: 'group-catalog',
		title: 'Catalog',
		type: 'group',
		children: [
			{
				id: 'catalog.featured',
				title: 'Featured',
				type: 'item',
				icon: 'lucide:star',
				url: 'catalog/featured'
			},
			{
				id: 'catalog.merge-review',
				title: 'Merge Review',
				type: 'item',
				icon: 'lucide:git-merge',
				url: 'catalog/merge-review'
			},
			{
				id: 'catalog.pipeline',
				title: 'Pipeline',
				type: 'item',
				icon: 'lucide:activity',
				url: 'catalog/pipeline'
			}
		]
	},
	{
		id: 'group-status',
		title: 'Status',
		type: 'group',
		children: [
			{
				id: 'status.overview',
				title: 'Overview',
				type: 'item',
				icon: 'lucide:layout-grid',
				url: 'health'
			},
			{
				id: 'status.sentry',
				title: 'Sentry',
				type: 'item',
				icon: 'lucide:bug',
				url: 'health/sentry'
			},
			{
				id: 'status.cron',
				title: 'Cron Jobs',
				type: 'item',
				icon: 'lucide:timer',
				url: 'health/cron'
			},
			{
				id: 'status.ai-usage',
				title: 'AI Usage',
				type: 'item',
				icon: 'lucide:sparkles',
				url: 'ai-usage'
			},
			{
				id: 'status.supabase',
				title: 'Supabase',
				type: 'item',
				icon: 'lucide:database',
				url: 'health/supabase'
			}
		]
	}
];

export default navigationConfig;
